export default "__VITE_ASSET__ru13h_qG__"